import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorAdminService } from "../../../services/api/vendor-admin.service";
import { VendorAdminActions } from "../../actions/vendor-admin.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class VendorAchRemoveEffects {
	remove = createEffect(() =>
		this.actions.pipe(
			ofType(VendorAdminActions.ach.remove),
			switchMap((action) =>
				this.vendorAdminService.removeBankAccount(action.accountId).pipe(
					map(() => VendorAdminActions.ach.removeSuccess()),
					catchError((error) =>
						of(VendorAdminActions.ach.removeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorAdminService: VendorAdminService
	) {}
}
